// extracted by mini-css-extract-plugin
module.exports = {"container":"Clientes_container__3d_hS","toolBar":"Clientes_toolBar__1uFww","qtdeRows":"Clientes_qtdeRows__2EYuT","columnAction":"Clientes_columnAction__3PGpa"};